function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import Cleave from 'cleave.js/react';
import 'cleave.js/dist/addons/cleave-phone.us';
import React, { useMemo } from 'react';
import { useDebounce } from '../../../hooks/use-debounce';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpPhoneInputStyle } from './style';
var OwnUpPhoneInputImpl = createOwnUpComponent(Cleave, OwnUpPhoneInputStyle);
export var OwnUpPhoneInput = function OwnUpPhoneInput(_ref) {
  var className = _ref.className,
      placeholder = _ref.placeholder,
      value = _ref.value,
      debounce = _ref.debounce,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      _ref$phoneRegionCode = _ref.phoneRegionCode,
      phoneRegionCode = _ref$phoneRegionCode === void 0 ? 'US' : _ref$phoneRegionCode,
      _ref$delimiter = _ref.delimiter,
      delimiter = _ref$delimiter === void 0 ? '-' : _ref$delimiter,
      props = _objectWithoutProperties(_ref, ["className", "placeholder", "value", "debounce", "onFocus", "onBlur", "onChange", "phoneRegionCode", "delimiter"]);

  // Build debounce state hooks based on input props.
  var debounceState = useDebounce({
    value: value,
    debounce: debounce,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange
  }); // Class name

  var builtClass = useMemo(function () {
    return buildClassNames('ou-phone-input', className);
  }, [className]);
  var options = useMemo(function () {
    return {
      phone: true,
      phoneRegionCode: phoneRegionCode,
      delimiter: delimiter
    };
  }, [delimiter, phoneRegionCode]);
  return /*#__PURE__*/React.createElement(OwnUpPhoneInputImpl, _extends({
    className: builtClass,
    placeholder: placeholder,
    options: options
  }, debounceState, props, {
    type: "tel"
  }));
};